import SignupCongratulationAnimationPage from "@faire/prototype-playground/workspace/mz/signup-congratulation-animation";
import { Route, Switch } from "react-router-dom";
import CalculatingNetTermsPage from "@faire/prototype-playground/workspace/mz/calculating-net-terms";

export function MichaelZhangRoutes() {
  return (
    <Switch>
      <Route path="/mz/calculating-net-terms" component={CalculatingNetTermsPage} />
      <Route
        path="/mz/signup-congratulation-animation"
        component={SignupCongratulationAnimationPage}
      />
    </Switch>
  );
}

export const slug = "mz";
